import request from '@/utils/request'

let WowApi = {
  /*获取数据*/
  getData(data) {
    return request._post('/shop/plus.wow.wow/index', data);
  },
  /*保存数据*/
  saveData(data) {
    return request._post('/shop/plus.wow.wow/saveData', data);
  },
}
export default WowApi;



// WEBPACK FOOTER //
// ./src/api/wow.js